/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Loader.css';

function Loader() {
    return (
        <div className={`spinner`}></div>
    );
}

export default withStyles(s)(Loader);



// WEBPACK FOOTER //
// ./components/Loader/Loader.js